export const WRAPPER_MIN_HEIGHT = 302
export const BUTTON_MIN_WIDTH = 140
export const ILLUSTRATION_ECARD_URL =
  'https://images.contentful.com/3m6f3dx67i1j/2oKbN2XSVyBzMzisPzWhDx/8dddcf8c7faf24ae1b8609e87c1367b1/Illustration.Ecard.png'
